m = require 'mithril'

ActionFactories = require '../../state/ActionFactories'

CommonViews = require '../components/CommonViews'
Breadcrumbs = require '../components/Breadcrumbs'
ExportPane 	= require '../components/ExportPane'
ImportPane 	= require '../components/ImportPane'

DataPage = {
	controller: (args) ->
		ctrl = @
		ctrl.onImport = (games) ->
			args.onImport games
			m.route '/'
		ctrl

	view: (ctrl, args) ->
		CommonViews.page [
			m Breadcrumbs, {items: [
				{url: '/', label: 'Games', icon: CommonViews.icons.home}
				{url: '/settings', label: 'Settings'}
				{label: 'Data Import/Export'}
			]}

			CommonViews.pageHeading 'Data Import/Export'
			m 'p', 'You can import your games onto this device by copy and pasting exported data into the import box below.  You can find data to export in the export box below.'
			m ExportPane, {games: args.games}
			m ImportPane, {onImport: ctrl.onImport}
		]
}

module.exports = (store) ->
	m DataPage, {
		games: () -> g for id,g of store.getState().gamesById
		onImport: (games) -> store.dispatch ActionFactories.gamesImported games
	}